export default "__VITE_ASSET__BHyQDBJn__"